import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Flex,
  Box,
  Text,
  IconButton,
} from '@chakra-ui/react'
import { MdCameraAlt, MdCameraEnhance } from 'react-icons/md'
import { FiRotateCw } from 'react-icons/fi'

export function CameraView({ isOpen, onClose, videoRef, canvasRef, onCapture, currentIndex }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" motionPreset="slideInBottom">
      <ModalOverlay />
      <ModalContent bg="#313E44" height="100%">
        <ModalHeader color="white">
          <Flex align="center" gap={2}>
            <MdCameraEnhance />
            <Text>Tirar Foto {currentIndex + 1}</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color="white" />

        <ModalBody p={0} display="flex" flexDirection="column">
          <Box flex="1" position="relative" overflow="hidden" display="flex" alignItems="center" justifyContent="center">
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
            <canvas ref={canvasRef} style={{ display: 'none' }} />

            <Box
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              width="80%"
              height="80%"
              border="2px dashed rgba(255, 255, 255, 0.5)"
              borderRadius="md"
              pointerEvents="none"
            />
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center" py={6} bg="#272f33">
          <Flex gap={4} align="center">
            <IconButton
              aria-label="Alternar câmera"
              icon={<FiRotateCw size={24} />}
              variant="ghost"
              color="white"
              _hover={{ bg: '#3a4a53' }}
              size="lg"
            />

            <IconButton
              aria-label="Tirar foto"
              icon={<MdCameraAlt size={36} />}
              bg="#37F091"
              color="#313E44"
              onClick={onCapture}
              size="lg"
              borderRadius="full"
              h="70px"
              w="70px"
              _hover={{ bg: '#2cdf7f' }}
            />

            <Button variant="ghost" onClick={onClose} color="white" _hover={{ bg: '#3a4a53' }}>
              Cancelar
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
